__turbopack_context__.v({
  "actions": "xdod7q_actions",
  "body": "xdod7q_body",
  "bridge": "xdod7q_bridge",
  "bridgeText": "xdod7q_bridgeText",
  "code": "xdod7q_code",
  "codeBar": "xdod7q_codeBar",
  "figure": "xdod7q_figure",
  "figureLabel": "xdod7q_figureLabel",
  "figureValue": "xdod7q_figureValue",
  "figures": "xdod7q_figures",
  "fine": "xdod7q_fine",
  "h2": "xdod7q_h2",
  "h3": "xdod7q_h3",
  "head": "xdod7q_head",
  "lead": "xdod7q_lead",
  "list": "xdod7q_list",
  "mono": "xdod7q_mono",
  "num": "xdod7q_num",
  "section": "xdod7q_section",
  "spec": "xdod7q_spec",
  "split": "xdod7q_split",
  "stepBody": "xdod7q_stepBody",
  "stepTitle": "xdod7q_stepTitle",
  "steps": "xdod7q_steps",
  "table": "xdod7q_table",
  "tableWrap": "xdod7q_tableWrap",
  "veil": "xdod7q_veil",
});
